import React, { useState } from "react";
import PropTypes from "prop-types";
import MessageBox from "../components/shared/components/MessageBox";

const ConfirmContext = React.createContext();
const useConfirm = () => {
  const context = React.useContext(ConfirmContext);
  if (context === undefined) {
    throw new Error("useConfirm must be used within a cofirmProvider");
  }
  return context;
};

const ConfirmProvider = ({ children }) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [confirmTitle, setConfirmTitle] = useState("");
  const [confirmButtons, setConfirmButtons] = useState("");
  const [confirmCallback, setConfirmCallback] = useState(() => () => {});
  const [cancelCallback, setCancelCallback] = useState(() => () => {});

  const openConfirm = ({
    text = "Wollen sie fortfahren?",
    title = "Auswahl Bestätigen",
    buttons = "YESNO",
  }) => {
    setConfirmText(text);
    setConfirmTitle(title);
    setConfirmButtons(buttons);
    setIsConfirmOpen(true);

    return new Promise((resolve, reject) => {
      setConfirmCallback(() => (resolveValue) => {
        setIsConfirmOpen(false);
        resolve(resolveValue);
      });
      setCancelCallback(() => (rejectValue) => {
        setIsConfirmOpen(false);
        reject(rejectValue);
      });
    });
  };

  openConfirm.PropTypes = {
    text: PropTypes.string,
    title: PropTypes.string,
    buttons: PropTypes.oneOf(["YESNO", "OK", "RETRYCANCEL"]),
  };

  const handleCancel = () => {
    cancelCallback("CANCEL");
  };

  const handleResponse = (response) => {
    if (['YES', 'OK', 'RETRY'].includes(response)) {
      console.log("confirm", response);
      confirmCallback(response);
    } else {
      console.log("cancel", response);
      cancelCallback(response);
    }
  }

  const ConfirmDialog = () => (
    <MessageBox
      title={confirmTitle}
      text={confirmText}
      buttons={confirmButtons}
      onClose={handleCancel}
      open={isConfirmOpen}
      handleResponse={handleResponse}
    />
  );

  return (
    <ConfirmContext.Provider value={openConfirm}>
      {children}
      <ConfirmDialog />
    </ConfirmContext.Provider>
  );
};

export { ConfirmProvider, useConfirm };
